import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { IoAlertCircleSharp } from "react-icons/io5";
import LoadingComponent from "../Components/LoadingComponent";
import useAuth from "../useAuth";
import { server } from "../server";
import axios from "axios";
export default function LoginPage() {
  // const navigate =  useNavigate()
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedPassword, setIsFocusedPassword] = useState(false);
  const { user, authMessage, loading, loginWithEmailAndPassword } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    loginWithEmailAndPassword(email, password);
  };

  if (user) {
    return <Navigate to="/my/home" />;
  }

  return (
    <div className="flex bg-gradient-to-br from-blue-50 via-cyan-50 to-blue-100 min-h-screen">
      <div className="flex w-1/2 my-auto h-screen">
        <div className="my-auto p-20 animate-sliogo">
          <h1 className="text-7xl font-bold bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-700 bg-clip-text text-transparent drop-shadow-lg">
            AUTHENTICATION
          </h1>
          <p className="text-xl mt-6 text-blue-700/70 font-medium">
          
            Secure access to your account
          </p>
        </div>
      </div>
      <form
        onSubmit={handleLogin}
        className="w-1/2 flex justify-center items-center animate-slide-from-right"
      >
        <div className="h-[60dvh] relative rounded-3xl bg-white/90 backdrop-blur-xl shadow-2xl shadow-blue-200/50 w-96 border border-blue-100 p-6">
          <div className="text-left p-2 mt-8">
            <h1 className="text-4xl ml-4 font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
              Login
            </h1>
            <h2 className="ml-4 mt-2 text-blue-600 font-semibold">
              Please sign in to continue.
            </h2>
          </div>
          <div className="mt-14 mx-2 p-4">
            {/* Email Input with Floating Label */}
            <div className="relative mb-8">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                className={`w-full px-4 py-3 bg-transparent border-2 rounded-lg outline-none focus:outline-none focus:ring-0 transition-all duration-300 ${
                  isFocused
                    ? 'border-blue-500 shadow-lg shadow-blue-200/50'
                    : 'border-blue-200'
                }`}
                placeholder=" "
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
              />
              <label
                htmlFor="email"
                className={`absolute left-4 transition-all duration-300 pointer-events-none ${
                  isFocused || email
                    ? '-top-2.5 text-xs bg-white px-2 text-blue-600 font-semibold'
                    : 'top-3 text-base text-gray-400'
                }`}
              >
                Email Address
              </label>
            </div>

            {/* Password Input with Floating Label */}
            <div className="relative mb-6">
              <input
                type="text"
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                className={`w-full px-4 py-3 bg-transparent border-2 rounded-lg outline-none focus:outline-none focus:ring-0 transition-all duration-300 ${
                  isFocusedPassword
                    ? 'border-blue-500 shadow-lg shadow-blue-200/50'
                    : 'border-blue-200'
                }`}
                placeholder=" "
                onFocus={() => setIsFocusedPassword(true)}
                onBlur={() => setIsFocusedPassword(false)}
              />
              <label
                htmlFor="password"
                className={`absolute left-4 transition-all duration-300 pointer-events-none ${
                  isFocusedPassword || password
                    ? '-top-2.5 text-xs bg-white px-2 text-blue-600 font-semibold'
                    : 'top-3 text-base text-gray-400'
                }`}
              >
                Password
              </label>
            </div>

            <br />
          </div>
          <div className="text-center text-red-500 capitalize flex justify-center items-center gap-2">
            {authMessage && (
              <div className="text-xl">
                <IoAlertCircleSharp />
              </div>
            )}
            {authMessage?.slice(5).split("-").join(" ")}
          </div>
          <div className="absolute right-10">
            <button
              type="submit"
              className="bg-gradient-to-r select-none flex shadow-lg shadow-blue-300/50 from-blue-500 via-cyan-500 to-blue-600 hover:from-blue-600 hover:via-cyan-600 hover:to-blue-700 gap-2 items-center text-white font-semibold w-fit rounded-full px-8 py-3 transition-all duration-300 hover:shadow-xl hover:shadow-blue-400/50 hover:scale-105"
            >
              LOGIN
              <BsArrowRight className="text-lg" />
            </button>
          </div>
        </div>
      </form>

      {loading && <LoadingComponent />}
    </div>
  );
}
